/**
 * Centralized status values for learning-path steps (courses + tracker).
 *
 * We keep the exported types as string unions because these values often come from
 * JSON/network payloads and tests use raw strings. The enum provides a single,
 * controlled source of truth for comparisons and future changes.
 * The last step is always a Google Tracker step.
 */
export enum LearningPathStepStatus {
    Completed = 'completed',
    InProgress = 'in_progress',
}

export enum LearningPathStepType {
    Course = 'course',
    Tracker = 'google_tracker',
}

/**
 * Path-level progress state for the user
 */
export enum LearningPathProgressState {
    NotEnrolled = 'not_enrolled',
    NotStarted = 'not_started',
    InProgress = 'in_progress',
    Completed = 'completed',
}

export type StepStatus = 'completed' | 'in_progress';
export type CourseStatus = StepStatus;
